<template>
    <footer class="footer">
        <ul>
            <li>© {{ currentYear }}, Idenfo Ltd. All rights reserved.</li>
            <li>
                <router-link v-b-modal.terms-service-popup to="#">
                    Terms of Service
                </router-link>
            </li>
            <li>
                <router-link v-b-modal.privacy-policy-popup to="#"
                    >Privacy Policy</router-link
                >
            </li>
        </ul>
        <terms-service-popup></terms-service-popup>
        <privacy-policy-popup></privacy-policy-popup>
    </footer>
</template>

<script>
import termsServicePopup from '@/components/popups/TermsServicePopup.vue'
import privacyPolicyPopup from '@/components/popups/PrivacyPolicyPopup.vue'
export default {
    components: { termsServicePopup, privacyPolicyPopup },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
